import * as React from 'react';
export const kbankSvg = React.forwardRef(function kbankSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#120063',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M11.042 22.991h-1.011l-1.602 1.793V22.99h-.81v3.911h.81V25.11l1.652 1.792h1.012l-1.804-1.955 1.753-1.956Zm1.99 1.109c-.337 0-.624.146-.86.341v-1.45h-.81v2.575c0 .782.54 1.434 1.535 1.434.894 0 1.535-.603 1.535-1.434-.017-.799-.557-1.467-1.4-1.467Zm-.152 2.2c-.421 0-.759-.327-.759-.718v-.016c0-.081.017-.163.034-.244a.763.763 0 0 1 .725-.506c.422 0 .76.326.76.734 0 .407-.338.75-.76.75Zm7.235-2.2c-.388 0-.692.13-.928.341v-.26h-.81v2.721h.81V25.37c0-.31.27-.57.59-.57.32 0 .59.26.59.57v1.532h.81v-1.776c.017-.57-.472-1.027-1.062-1.027Zm-3.778 0c-.91 0-1.551.602-1.551 1.433 0 .799.556 1.45 1.4 1.45.387 0 .758-.195.96-.472v.375h.726V25.5c.017-.75-.523-1.402-1.535-1.402Zm.017 2.183a.743.743 0 0 1-.759-.733c0-.408.338-.734.76-.734.42 0 .758.326.758.734.017.407-.32.733-.759.733Zm8.027.587-1.214-1.353 1.18-1.336h-.877l-1.011 1.157v-2.363h-.81v3.895h.81v-1.174l1.045 1.174h.877Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16 11.176 7.636 5v15.726h3.372v-9.224L16 15.25l4.991-3.748v9.224h3.373V5L16 11.176Z',
      fill: '#BCF100',
    }),
  );
});
kbankSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var kbank = {
  category: 'brand',
  colorable: false,
  name: 'kbank',
  svg: kbankSvg,
};
